import { AutocompleteInput, useGetOne } from 'react-admin';

export default function SelectSubMerchantFieldCreate({ allSubmerchants }) {
  const { data, isLoading } = useGetOne('Employee', {});

  if (isLoading)
    return (
      <AutocompleteInput
        optionText="name"
        source="submerchantID"
        label="Submerchant"
        variant="outlined"
        emptyText="Loading..."
        choices={[]}
        fullWidth
      />
    );

  return (
    <AutocompleteInput
      optionText="name"
      parse={(value) => (value === '' ? 0 : value)}
      defaultValue={data.submerchantID}
      source="submerchantID"
      label="Submerchant"
      variant="outlined"
      choices={allSubmerchants}
      fullWidth
    />
  );
}
